import React from 'react';
// import Button from '@material-ui/core/Button';
import CustomButton from '../../ui-elements/CustomButton/CustomButton';

export default function LocationSearchConfirm(props) {
    return (
		<CustomButton title={props.title} type="button" onClick={props.onClick} disabled={props.isDisabled} style={props.style} classList="location-search-confirm" />
			
	);
}